<template>
  <div>
    <FormField id="iban" v-model="iban" placeholder="FR76 3000 6000 0112 3456 7890 189" />
    <div class="mt-4">
      <FileField
        id="iban-document"
        :form-data="formData"
        label="Justificatif IBAN"
        placeholder="Déposez votre RIB ou relevé bancaire"
        :required="!documentUrl"
        @files="onFilesChange"
      />
      <ExtractionStatus
        :extracting="extractingIban"
        :extraction-error="ibanExtractionError"
        :extraction-success="ibanExtractionSuccess"
        :extracting-label="t('iban_extraction_extracting')"
        :error-label="ibanExtractionFailed ? t('iban_extraction_failed') : t('iban_extraction_not_found')"
        :success-label="t('iban_extraction_success')"
        @dismiss-success="ibanExtractionSuccess = false"
      />
      <p v-if="documentUrl" class="mt-1 text-sm text-gray-500">
        <a :href="documentUrl" target="_blank" rel="noopener noreferrer" class="text-primary underline">
          Voir le justificatif existant
        </a>
      </p>
    </div>
    <div class="flex justify-end mt-6">
      <GenericButton :disabled="!isValid" @click="submit">Enregistrer</GenericButton>
    </div>
  </div>
</template>

<script>
import { ExtractionStatus, FileField, FormField, GenericButton, extractIbanMixin } from "@estaly/ui";
import { useI18n } from "vue-i18n";
import { mapActions } from "vuex";

export default {
  components: {
    ExtractionStatus,
    FileField,
    FormField,
    GenericButton,
  },
  mixins: [extractIbanMixin],
  setup() {
    const { t } = useI18n();
    return { t };
  },
  data() {
    return {
      iban: null,
      documentUrl: null,
      formData: new FormData(),
      hasFile: false,
    };
  },
  computed: {
    isValid() {
      return !!this.iban && (this.hasFile || !!this.documentUrl);
    },
  },
  async mounted() {
    const response = await this.fetch();
    this.iban = response?.value;
    this.documentUrl = response?.documentUrl;
  },
  methods: {
    ...mapActions("notifications", ["notify"]),
    ...mapActions("iban", ["fetch", "update", "extractIban"]),
    onFilesChange() {
      this.hasFile = !!this.formData.get("iban-document");
      this.runIbanExtraction(this.formData.get("iban-document"));
    },
    async submit() {
      const file = this.formData.get("iban-document");
      const success = await this.update({
        iban: this.iban,
        document: file,
      });
      if (!success) return;

      if (file) {
        const response = await this.fetch();
        this.documentUrl = response?.documentUrl;
        this.formData.delete("iban-document");
        this.hasFile = false;
      }

      this.notify({
        category: "simple",
        type: "success",
        title: "Iban mis à jour",
      });
    },
  },
};
</script>

<i18n src="./IbanForm.i18n.json"></i18n>
